import { Injectable } from "@angular/core";
import { GenericResponse } from "../../../../Autofacets-Core/src/app/business-entities/generic-response.class";
import { CustomerDetailsViewModel, CustomerModel, DuplicateCustomerRequestModel } from "../business-entities/customer-view.model";
import { CustomerDealerAssociationResponseModel } from "../business-entities/customer-dealer-association-response-model.model";
import { CustomerListRequestModel } from "../business-entities/customerList-request-model";
import { CustomerDataService } from "../data-services/customer-data.service";
import { isNullOrUndefined } from '@swimlane/ngx-datatable';
import { EnvSetting } from 'projects/Autofacets-Core/src/app/utils/env-setting';

@Injectable({
    providedIn: 'root'
})

export class CustomerService {
    customerId: number;
    vehicleId: number;
    customerNo: string;
    customerName: string;
    firstName:string;
    lastName:string;
    logo: any;
    customerMobileNo: string;
    customerFromCaller: any;
    contactId: string; //Guid of Customer
    crmVehicleObj: any;
    customerListRequest: CustomerListRequestModel =
        {
            searchTerm: '',
            startRecordNumber: 0,
            pageSize: 25,
            sortColumn: '',
            sortDirection: '',
            isForDocuments: false,
            customerTypeId: 0,
            customerName: '',
            firstName:'',
            lastName:'',
            customerNo: '',
            customerGroup: null,
            salutation: null,
            postCode: null,
            city: null,
            email: '',
            mobile: '',
            licensePlateNo: '',
            statusId: 0,
            syncId: 0,
            sourceOfCreation: '',
            dealerName: '',
            isDeleted:false,
            dealerId:'',
            isAdvanceSearch:false
        }
    customerDetail: any;//Used for Communication list
    IsCustomerAddFromVehicle:boolean;
    VehicleNumber:string;
    CustomerId: string;
    CustomerNumber: string;
    constructor(private service: CustomerDataService) {
    }

    async getCustomerList(requestModel: CustomerListRequestModel): Promise<GenericResponse<any>> {
        return this.service.getCustomerList(requestModel);
    }

    async GetCustomerPrivacyLogById(id: number): Promise<GenericResponse<any>> {
        return  this.service.GetCustomerPrivacyLogById(id);
    }

    async CheckCustomerDuplication(model:any): Promise<GenericResponse<any>>
    {
        return this.service.CheckCustomerDuplication(model);
    }

    async getCustomerById(id: number): Promise<GenericResponse<CustomerDetailsViewModel>> {
        return  this.service.getCustomerById(id);
    }

    async getCustomerDealerAssociationById(id: number): Promise<GenericResponse<CustomerDealerAssociationResponseModel>> {
        return  this.service.getCustomerDealerAssociationById(id);
    }

    async addCustomerDiscount(model: any): Promise<any> {
        return  this.service.addCustomerDiscount(model);
    }

    async addEditCustomer(customerInfo: CustomerModel): Promise<any> {
        return  this.service.AddEditCustomer(customerInfo);
    }

    async crmAddEditCustomer(customerInfo: any): Promise<any> {
        return  this.service.crmAddEditCustomer(customerInfo);
    }

    async GetCustomerGroupDropdown(): Promise<any> {
        return  this.service.GetCustomerGroupDropdown();
    }

    async GetAddressSalutationDropdown(): Promise<any> {
        return  this.service.GetAddressSalutationDropdown();
    }

    async GetPostCodeDropdown(): Promise<any> {
        return  this.service.GetPostCodeDropdown();
    }

    getCountryCodeAndMobileCodeDetails(): Promise<GenericResponse<any>> {
        return this.service.getCountryCodeAndMobileCodeDetails();
    }

    async CheckDuplicateCustomer(customerInfo: DuplicateCustomerRequestModel): Promise<any> {
        return  this.service.CheckDuplicateCustomer(customerInfo);
    }

    async ResyncCustomer(id: number, moduleId: number): Promise<GenericResponse<any>> {
        return  this.service.ResyncCustomer(id, moduleId);
    }
    async getDFCustomerListByFullSearch(search:string): Promise<GenericResponse<any>> {
        return  this.service.getDFCustomerListByFullSearch(search);
    }
    async getDFCustomerListByAdvanceSearch(advanceSearchRequest:any): Promise<GenericResponse<any>> {
        return  this.service.getDFCustomerListByAdvanceSearch(advanceSearchRequest);
    }
    async getEMCustomerListByAdvanceSearch(advanceSearchRequest:any): Promise<GenericResponse<any>> {
        return this.service.getEMCustomerListByAdvanceSearch(advanceSearchRequest);
    }
    async getAccountsAutoComplete(searchTerm: string): Promise<GenericResponse<any>> {
        return  this.service.getAccountsAutoComplete(searchTerm);
    }
    async GetCallHistoryList(model: any): Promise<GenericResponse<any>> {
        return  this.service.GetCallHistoryList(model);
    }
    async getCustomerDropdownByLicensePlateNo(licensePlateNo:string,apponitmentId:number = 0): Promise<GenericResponse<any>> {
        return  this.service.getCustomerDropdownByLicensePlateNo(licensePlateNo,apponitmentId);
    }

    async HarddeleteCustomer(model:any): Promise<GenericResponse<any>> {
        return  this.service.HarddeleteCustomer(model);
    }

    async getCustomerUpdateHistory(): Promise<GenericResponse<any>>{
        return await this.service.getCustomerUpdateHistory(this.customerDetail.customerId);
    }

    //#region DataFactory data mapping
    DFCustomerDataMapper(customer: any)
    {
        let supperArray = [];
        if (customer && customer.length > 0) {
            for (let element of  customer) {
                let personDetail; let name; let address; let phone; let registrationOrBirthDate; let customerType=0; let gender
                if (element.personDetail != null) {
                personDetail = element.personDetail
                registrationOrBirthDate = element.personDetail.birthDate;
                gender = element.personDetail.gender
                customerType = element.personDetail.gender == 'Female' ? 1 : 0;
                }
                else {
                registrationOrBirthDate = element?.companyDetail?.registrationDate;
                customerType = 2;
                }
                if (element.names?.length > 0) {
                    for (let i = 0; i < element.names.length; i++) {
                        if (element.names[i].sources != null || element.names[i].sources != undefined) {
                            for (const source of element.names[i].sources) {
                                if (source.name === "DSF") {
                                    name = element.names[i];
                                    if (element.phones?.length > 0) {
                                        phone = (element.phones.length === i + 1) ? element.phones[i] : element.phones[0];
                                    }
                                    if (element.addresses?.length > 0) {
                                        address = (element.addresses.length === i + 1) ? element.addresses[i] : element.addresses[0];
                                    }
                                } else {
                                    name = element.names[0];
                                    if (element.phones?.length > 0) {
                                        phone = element.phones[0];
                                    }
                                    if (element.addresses?.length > 0) {
                                        address = element.addresses[0];
                                    }
                                }
                            }
                    }
                    else {
                    name = element.names[0];
                    if (element.phones?.length > 0) {
                        phone = element.phones[0];
                    }
                    if (element.addresses?.length > 0) {
                        address = element.addresses[0];
                    }
                    }
                }
                }
                if (name != null || name != undefined) {
                name.firstName = (name?.firstName == null || name?.firstName == undefined) ? name?.fullName.split(" ")[0] : name?.firstName;
                name.lastName = (name?.lastName == null || name?.lastName == undefined) ? name?.fullName.split(" ")[1] : name?.lastName;
                }

                let single = Object();
                single.customerName = name?.fullName;
                single.addressLine1 = address?.address;
                single.city = address?.city;
                single.gender = gender;
                single.mobileNo = phone?.number;
                single.mobileCode = phone?.country;
                single.pincode = address?.postalCode;
                single.isSelected = false;
                single.firstName = name?.firstName;
                single.lastName = name?.lastName;
                single.registrationOrBirthDate =  registrationOrBirthDate ?? '';
                single.customerTypeId = customerType;
                single.addressLine2 = '';
                single.country = EnvSetting.Country;
                single.phoneNumber = '';
                single.registrationOrPersonNumber = '';
                single.email2 = '';
                single.fax = '';
                single.isRegularEmail = false;
                single.isEmail = false;
                single.isSms = false;
                single.isFax = false;
                single.isPhone = false;
                single.email = phone?.email;
                single.contactId = personDetail?.contactId;
                supperArray.push(single);
            }
        } else {
            for(let value of customer.result)
            {
                let single = Object();
                single.addressLine1 = (!isNullOrUndefined(value.address.street1)) ? value.address.street1 : '' ;
                single.city = (!isNullOrUndefined(value.address.city)) ? value.address.city : '' ;
                single.mobileNo = (!isNullOrUndefined(value.mobilePhone)) ? value.mobilePhone : '';
                single.pincode = (!isNullOrUndefined(value.address.postalCode)) ?  value.address.postalCode : '';
                single.isSelected = false;
                single.firstName = (!isNullOrUndefined(value.firstName)) ?value.firstName : '' ;
                single.lastName = (!isNullOrUndefined(value.lastName)) ? value.lastName : '';
                single.registrationOrBirthDate =  '';
                single.customerTypeId = '';
                single.addressLine2 = '';
                single.country = ''
                single.phoneNumber = '';
                single.registrationOrPersonNumber = '';
                single.email2 = '';
                single.contactId = value.contactId;
                single.fax = '';
                single.isRegularEmail = false;
                single.isEmail = false;
                single.isSms = false;
                single.isFax = false;
                single.isPhone = false;
                single.customerName = single.firstName + ' ' + single.lastName;
                single.gender = '';
                single.email = (!isNullOrUndefined(value.phone.email)) ? value.phone.email : '';
                single.contactId = (!isNullOrUndefined(value.personDetail.contactId)) ? value.personDetail.contactId : '';
                supperArray.push(single);
            }
        }
        return supperArray;
    }
    //#endregion
}
